// extracted by mini-css-extract-plugin
export default {"imageContainer":"PictureUpdater_imageContainer__V1PT+","buttonContainer":"PictureUpdater_buttonContainer__ql5TS","btn":"PictureUpdater_btn__1gok9"};